import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const useShowOnlyAlertQuantities = createGlobalState({
  storage: "session",
  key: "quantityShowOnlySymptomQuantities",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});
